import { render, staticRenderFns } from "./AwlCard.vue?vue&type=template&id=48b057c0&"
import script from "./AwlCard.vue?vue&type=script&lang=js&"
export * from "./AwlCard.vue?vue&type=script&lang=js&"
import style0 from "./AwlCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports